import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBQ: CultureInfo = {
  name: 'es-BQ',
  displayName: 'español (Caribe neerlandés)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BQ',
  parent: CultureInfoEs
};
